import { render, staticRenderFns } from "./BobTheBot.vue?vue&type=template&id=5b3a2248&scoped=true&"
import script from "./BobTheBot.vue?vue&type=script&lang=js&"
export * from "./BobTheBot.vue?vue&type=script&lang=js&"
import style0 from "./BobTheBot.vue?vue&type=style&index=0&id=5b3a2248&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3a2248",
  null
  
)

export default component.exports